import CountCell from 'components/CountCell';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function FleetsCountCell({
  rowData: { id, totals },
}: CellProps) {
  return (
    <CountCell
      count={totals?.fleets}
      pageParams={{
        tab: 'accounts',
        oemSegmentIds: [id],
        teamIds: [],
        accountIds: [],
        depotIds: [],
      }}
    />
  );
}
